<template>
    <div>
        <div class="primary-info" v-loading="infoLoading">
            <h3 class="title-group">目标账户：</h3>
            <p class="ml20">账户：{{accountListText}}</p>
            <h3 class="title-group">基础配置：</h3>
            <p class="ml20">
                新计划状态【{{formItem.plan_status=='1'?'关闭':'开启'}}】；
                <span v-if="dateType=='1'">
                    投放日期【长期投放（开始日期：{{range}}）】；
                </span>
                <span v-else>
                    投放日期【（开始日期：{{range1[0]}}，结束日期：{{range1[1]}}）】；
                </span>
                投放产品：<span v-for="item in appInfoData">{{item.app_name||'--'}}（{{item.app_id||'--'}}）（{{item.package_name||'--'}}）；</span>
            </p>
            <div class="tool-bar mt10">
                <el-button type="primary"  v-if="!isAimedia" plain size="mini" @click="showSettingModal('app_name')" :disabled="selectionRow.length<=0">修改应用名称</el-button>
                <el-button type="primary"  v-if="!isAimedia" plain size="mini" @click="showSettingModal('sub_title')" :disabled="selectionRow.length<=0">修改应用副标题</el-button>
                <el-button type="primary" plain size="mini" @click="showSettingModal('view_monitor_url')" :disabled="selectionRow.length<=0">修改曝光监测链接</el-button>
                <el-button type="primary" plain size="mini" @click="showSettingModal('click_monitor_url')" :disabled="selectionRow.length<=0">修改点击监测链接</el-button>
                <el-button type="primary" v-if="!isAimedia"  plain size="mini" @click="batchChangeAdName" :loading="batchAdNameLoading" :disabled="selectionRow.length<=0">
                    广告应用素材名称
                    <el-tooltip class="item" effect="dark" placement="top">
                        <i class="el-icon-question"></i>
                        <div slot="content">
                            <p>按照以下优先级取素材名称应用至广告名称：<br/>视频素材 > 图片素材 > 图标素材</p>
                        </div>
                    </el-tooltip>
                </el-button>
            </div>
        </div>
        <div class="table-wrap mt20">
            <el-table
                ref="table"
                :key="tableKey"
                :row-class-name="tableRowClassName"
                :header-cell-style="{background:'#e8eaec',color:'#333'}"
                border
                :data="tableData"
                @selection-change="selectionChange"
                style="width: 100%">
                <el-table-column
                    type="selection"
                    :selectable="(row,index)=>index!==0"
                    width="55">
                </el-table-column>
                <el-table-column
                    v-if="!isAimedia"
                    prop="detail_idea_id"
                    label="批量创建详情ID">
                </el-table-column>
                <el-table-column
                    v-else
                    prop="detail_id"
                    label="详情ID">
                </el-table-column>
                <el-table-column
                    prop="account_name"
                    show-overflow-tooltip
                    min-width="150"
                    label="目标账户">
                    <template slot-scope="scope">
                        <span v-if="scope.$index==0">{{scope.row.account_name}}</span>
                        <span v-else>{{scope.row.account_name}}-{{scope.row.user_name}}({{scope.row.account_id}})</span>
                    </template>
                </el-table-column>
                <el-table-column
                    prop="plan_name"
                    show-overflow-tooltip
                    min-width="150"
                    label="计划">
                </el-table-column>
                <el-table-column
                    prop="adgroup_name"
                    show-overflow-tooltip
                    min-width="150"
                    label="广告组">
                </el-table-column>
                <el-table-column
                    prop="ad_name"
                    show-overflow-tooltip
                    min-width="150"
                    label="广告">
                    <template slot-scope="scope">
                        <span v-if="scope.$index==0"> {{scope.row.ad_name}}</span>
                        <div v-else class="td-text-wrap inline-block pr20 ellipsis relative">
                            {{scope.row.ad_name||'--'}}
                            <span title="编辑" class="action-btn pointer icon iconfont icon-jt-bianji text-color-primary" @click="showSingleEditModal(scope.row,'ad_name')" ></span>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column label="投放产品" min-width="200">
                    <template slot-scope="scope">
                        <div v-if="scope.$index != 0">
                            <p>{{scope.row.deploy_app_name||'--'}}({{scope.row.deploy_app_id||'--'}})</p>
                            <p>{{scope.row.deploy_app_package_name}}</p>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column
                    prop="deeplink"
                    v-if="!isAimedia"
                    show-overflow-tooltip
                    width="150"
                    label="deeplink链接">
                    <template slot-scope="scope">
                        {{ scope.row.deeplink }}
                    </template>
                </el-table-column>
                <el-table-column
                    v-if="!isAimedia"
                    prop="place_type_text"
                    width="150"
                    label="展现形式">
                </el-table-column>
                <el-table-column
                    v-if="!isAimedia"
                    prop="app_name"
                    show-overflow-tooltip
                    width="150"
                    label="应用名称">
                </el-table-column>
                <el-table-column
                    prop="sub_title"
                    show-overflow-tooltip
                    width="150"
                    v-if="!isAimedia"
                    label="应用副标题">
                </el-table-column>
                <el-table-column
                    prop="view_monitor_url"
                    show-overflow-tooltip
                    width="150"
                    label="曝光监测链接">
                </el-table-column>
                <el-table-column
                    prop="click_monitor_url"
                    show-overflow-tooltip
                    width="150"
                    label="点击监测链接">
                    
                </el-table-column>
              
                <el-table-column
                    prop="norm_model_text"
                    width="150"
                     v-if="!isAimedia"
                    label="创意规格">
                </el-table-column>
                <el-table-column
                    v-if="!isAimedia"
                    prop="idea"
                    min-width="300"
                    label="创意">
                    <template slot-scope="scope">
                        <span v-if="scope.$index==0">{{scope.row.idea}}</span>
                        <template v-else>
                            <div class="material-list-wrap">
                                <div class="mr10 material-item" v-for="(material, ii) in scope.row.material" :key="ii">
                                    <div class="material-view">
                                        <el-popover
                                            placement="top"
                                            width="500"
                                            popper-class="vivo-batch-material-pre-popover"
                                            trigger="hover">
                                            <div class="pop-content">
                                                <img class="pre-material" v-if="material.material_type == 1" :src="material.material_url"/>
                                                <video class="pre-material"
                                                    controls="controls"
                                                    :src="material.material_url"
                                                    v-if="material.material_type == 2"
                                                ></video>
                                            </div>
                                            <div slot="reference">
                                                <div class="mini-material-wrap">
                                                    <img class="mini-material" v-if="material.material_type == 1" :src="material.material_url"/>
                                                    <video class="mini-material"
                                                        v-if="material.material_type == 2"
                                                        :src="material.material_url"
                                                    ></video>
                                                </div>
                                            </div>
                                        </el-popover>
                                    </div>
                                    <div class="ellipsis" style="display: block;">
                                        <p class="material-name-text ellipsis" :title="material.material_name">{{material.material_name}}</p>
                                    </div>
                                </div>
                            </div>
                        </template>
                    </template>
                </el-table-column>
                <el-table-column  v-if="isAimedia" label="文案" min-width="200" prop="title_list">
                    <!-- title_list -->
                    <template slot-scope="scope">
                        <div v-if="scope.$index != 0">
                           <TextEllips v-for="(text, index) in scope.row.title_list" :key="text + index" :text="text" />
                        </div>
                    </template>
                </el-table-column>
                <el-table-column
                    prop="img_list"
                    :min-width="infoData.base_info.img_num * 90"
                     v-if="isAimedia"
                    label="图片">
                    <template slot-scope="scope">
                        <span v-if="scope.$index==0">{{scope.row.img_num}}</span>
                        <template v-else>
                            <div class="material-list-wrap" :style="{ width: scope.row.img_list.length*80+'px' }">
                                <div class="mr10 material-item" v-for="(material, ii) in scope.row.img_list" :key="ii">
                                    <div class="material-view">
                                        <el-popover
                                            placement="top"
                                            width="500"
                                            popper-class="vivo-batch-material-pre-popover"
                                            trigger="hover">
                                            <div class="pop-content">
                                                <img class="pre-material"  :src="material.full_material_url"/>
                                               
                                            </div>
                                            <div slot="reference">
                                                <div class="mini-material-wrap">
                                                    <img class="mini-material" :src="material.full_material_url"/>
                                                </div>
                                            </div>
                                        </el-popover>
                                    </div>
                                    <div class="ellipsis" style="display: block;">
                                        <p class="material-name-text ellipsis" :title="material.material_name">{{material.material_name}}</p>
                                    </div>
                                </div>
                            </div>
                        </template>
                    </template>
                </el-table-column>
                <el-table-column
                    v-if="infoData.base_info.video_num > 0 && isAimedia"
                    prop="video_list"
                    :min-width="infoData.base_info.video_num * 180"
                    label="视频">
                    <template slot-scope="scope">
                        <span v-if="scope.$index==0">{{scope.row.video_num}}</span>
                        <template v-else>
                            <div class="material-list-wrap" :style="{ width: scope.row.video_list.length*160+'px' }">
                                <template v-for="(material, ii) in scope.row.video_list">
                                    <div class="mr10 material-item"  :key="ii + material.full_material_url">
                                        <div class="material-view">
                                            <el-popover
                                                placement="top"
                                                width="500"
                                                popper-class="vivo-batch-material-pre-popover"
                                                trigger="hover">
                                                <div class="pop-content">
                                                    <video class="pre-material"
                                                        controls="controls"
                                                        :src="material.full_material_url"
                                                    ></video>
                                                </div>
                                                <div slot="reference">
                                                    <div class="mini-material-wrap">
                                                        <video class="mini-material"
                                                            :src="material.full_material_url"
                                                        ></video>
                                                    </div>
                                                </div>
                                            </el-popover>
                                        </div>
                                        <div class="ellipsis" style="display: block;">
                                            <p class="material-name-text ellipsis" :title="material.material_name">{{material.material_name}}</p>
                                        </div>
                                    </div>
                                    <div class="mr10 material-item"  :key="ii + material.full_preview_material_url">
                                        <div class="material-view">
                                            <el-popover
                                                placement="top"
                                                width="500"
                                                popper-class="vivo-batch-material-pre-popover"
                                                trigger="hover">
                                                <div class="pop-content">
                                                    <img class="pre-material"  :src="material.full_preview_material_url"/>
                                                
                                                </div>
                                                <div slot="reference">
                                                    <div class="mini-material-wrap">
                                                        <img class="mini-material" :src="material.full_preview_material_url"/>
                                                    </div>
                                                </div>
                                            </el-popover>
                                        </div>
                                        <div class="ellipsis" style="display: block;">
                                            <p class="material-name-text ellipsis" :title="material.preview_material_name">{{material.preview_material_name}}</p>
                                        </div>
                                    </div>
                                </template>
                               
                            </div>
                        </template>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <div class="page-bar mt20 tac">
            <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="queryData.pn"
                :page-sizes="[10, 30, 50,100]"
                :page-size="queryData.rn"
                layout="total, sizes, prev, pager, next, jumper"
                :total="totalCnt">
            </el-pagination>
        </div>

        <IdeaSettingModal ref="ideaSettingModal" :data="selectionRow" :type="actionType" @update="getDataList"/>
        <SingleIdeaSettingModal ref="singleIdeaSettingModal" :data="singleActionRow" :type="singleActionType" @update="getDataList"/>
    </div>
</template>

<script>

    import API from '@/api/marketManage/vivoBatch';
    import IdeaSettingModal from '../modal/ideaSettingModal';
    import SingleIdeaSettingModal from '../modal/singleIdeaSettingModal';
    import TextEllips from '@/components/TextEllips'
    export default {
        name: "IdeaResult",
        props:{
            taskId:{
                type:[String,Number],
                required:true,
            },
            isAimedia:{
                type: Boolean,
                required:false,
            },
            
            formItem:{
                type:Object,
                required:true,
            },
            dateType:[String,Number],
            range:{
                type:String,
                required:true,
            },
            range1:{
                type:Array,
                required:true,
            },
        },
        components:{
            IdeaSettingModal,
            SingleIdeaSettingModal,
            TextEllips
        },
        data(){
            return {
                queryData:{
                    pn:1,
                    rn:10,
                },
                totalCnt:0,
                infoLoading:false,
                dataLoading:false,
                infoData:{
                    account_info:[],
                    base_info:{
                        "plan_status": "",
                        "plan_status_text": "",
                        "skip_ocpx_stage": null,
                        "skip_ocpx_stage_text": null,
                        "group_start_date": "",
                        "group_end_date": "",
                        "group_date_type": "",
                        app_info:[],
                    },
                    total:{
                        "account_num": 0,
                        "plan_num": 0,
                        "adgroup_num": 0,
                        "img_num": 0,
                        "video_num": 0,
                        "ad_num": 0,
                        "idea_num": 0
                    },
                },
                dataList:[],
                selectionRow:[],
                actionType:'',
                singleActionType:'',        //单个编辑的类型
                singleActionRow:{},         //单个编辑的列
                batchAdNameLoading:false,
                tableKey: 1,
            }
        },
        computed:{
            accountListText(){
                return this.infoData.account_info.map(item=>`${item.account_name}（用户名:${item.user_name}）`).join('，')||'-';
            },
            tableData(){
                let totalData = this.infoData.total||{};
                let sumRow = {
                    index:'-',
                    account_name:totalData.account_num,
                    plan_name:totalData.plan_num,
                    adgroup_name:totalData.adgroup_num,
                    ad_name:totalData.ad_num,
                    idea:totalData.idea_num,
                    video_num:totalData.video_num,
                    img_num:totalData.img_num,
                };
                return [sumRow].concat(this.dataList);
            },
            appInfoData(){
                let baseInfo = this.infoData.base_info||{};
                return baseInfo.app_info||[];
            },
        },
        methods:{
            getIdeaInfo(){
                this.getInfoData();
                this.getDataList();
            },
            getDataList(){
                this.dataLoading = true;
                this.$refs.table.clearSelection();
                this.selectionRow = [];
                // taskAiPreviewIdeaList taskPreviewIdeaList isAimedia
                API[this.isAimedia?'taskAiPreviewIdeaList':'taskPreviewIdeaList']({
                    task_id:this.taskId,
                    pn:this.queryData.pn,
                    rn:this.queryData.rn,
                }).then(res => {
                    let resData = res.data || {};
                    this.dataLoading = false;
                    let baseIndex = this.queryData.rn * (this.queryData.pn-1);
                    this.dataList = (resData.list || []).map((item,index)=>{
                        item.index = baseIndex+index+1;
                        return item;
                    });
                    this.totalCnt = resData.totalCnt;
                    this.tableKey++;
                    this.$nextTick(() => {
                        this.$refs.table.doLayout();
                    });
                    this.$refs.table.doLayout();
                }, (err) => {
                    console.log('getUserList error', err);
                    this.dataList = [];
                    this.dataLoading = false;
                    this.totalCnt = 0;
                });
            },
            getInfoData(){
                this.infoLoading = true;
                API.taskPreviewInfo({
                    task_id:this.taskId,
                    pn:this.queryData.pn,
                    rn:this.queryData.rn,
                }).then(res => {
                    let resData = res.data || {};
                    this.infoLoading = false;
                    this.infoData.account_info = resData.account_info||[];
                    this.infoData.base_info = resData.base_info||{};
                    this.infoData.total = resData.total||{};
                    this.tableKey++;
                    this.$nextTick(() => {
                        this.$refs.table.doLayout();
                    });
                }, (err) => {
                    console.log('getUserList error', err);
                    this.infoLoading = false;
                });
            },
            handleSizeChange(val){
                this.queryData.rn= val;
                this.getDataList();
            },
            handleCurrentChange(val){
                this.queryData.pn= val;
                this.getDataList();
            },
            tableRowClassName({row, rowIndex}) {
                if (rowIndex === 0) {
                    return 'gray-row';
                }
                return '';
            },
            selectionChange(val){
                this.selectionRow = val;
            },
            showSettingModal(type){
                this.actionType = type;
                this.$refs.ideaSettingModal.showModal();

            },
            showSingleEditModal(row,type){
                console.log('showSingleEditModal',row,type);
                this.singleActionRow = {...row};
                this.singleActionType = type;
                this.$refs.singleIdeaSettingModal.showModal();
            },
            batchChangeAdName(){
                console.log('batchChangeAdName',this.selectionRow);
                this.batchAdNameLoading = true;
                API.putMaterialNameToAdName({
                    detail_idea_ids:this.selectionRow.map(item=>item.detail_idea_id).join(','),
                }).then(res=>{
                    this.batchAdNameLoading = false;
                    this.$message.success(res.info||'请求成功');
                    this.getDataList();
                },err=>{
                    this.batchAdNameLoading = false;
                    this.$message.error(err.info||'请求异常');
                    this.getDataList();
                });
            },
        }
    }
</script>

<style lang="scss" scoped>
    .action-btn{
        position: absolute;
        right: 0;
    }
    .td-text-wrap{
        width: auto;
        max-width: 100%;
        top: 4px;
    }
    .primary-info{
        min-height: 100px;

        .title-group{
            font-size: 12px;
            margin: 10px 0;
        }
    }
    .material-list-wrap{
        display: flex;
    }

    .material-item{
        width: 80px;
        .mini-material{
            width: 100%;
            max-height: 80px;
            float: left;
        }
    }

    .material-name-text{
        padding: 0!important;
        line-height: 16px;
    }

    .table-wrap ::v-deep.el-table .gray-row{
        background-color: #f4f4f4;
    }
</style>
